import React from 'react';
import type {EmitEvent} from '../connect/ConnectElementEventEmitter';

export const EventEmitterContext = React.createContext<EmitEvent | null>(null);
EventEmitterContext.displayName = 'EventEmitterContext';

export const useEmitEvent = () => {
  const context = React.useContext(EventEmitterContext);
  if (!context) {
    throw new Error('Event emitter context should be defined');
  }

  return context;
};
